import React, { Component } from 'react';
import Backdrop from '@mui/material/Backdrop';
import heic2any from "heic2any";
import CircularProgress from '@mui/material/CircularProgress';
import { Big3Common } from '../../../js/IncludeManager'
import { GoodsPhoto } from '../../../js/ComponentManager'
import img_search from '../../../img/img_search.svg';
import before from '../../../img/before.svg';
import { DotLottiePlayer } from '@dotlottie/react-player';
import '@dotlottie/react-player/dist/index.css';
import loading from '../../../js/loading.json';
import Cropper from "react-cropper";
import 'cropperjs/dist/cropper.css';
import { Link } from 'react-router-dom';
import { DataContext } from '../../Layout';

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class SimilarGoods extends Component {
    static displayName = SimilarGoods.name;
    static contextType = DataContext;

    constructor(props) {
        super(props);
        this.state = {
            showBackdrop: false,
            GoodsImage: null,
            CropMode: null,
            showLoading: false,
            showInfoText: true,
            RenderName: "SimilarGoods",
            SimilarList: []
        };
        this.cropperRef = React.createRef();
        this.hiddenFileInputSimilar = React.createRef();
        this.handleFileSearchClick = this.handleFileSearchClick.bind(this);
        this.handleFileServerSend = this.handleFileServerSend.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handle_ChangeCrop = this.handle_ChangeCrop.bind(this);
        this.handle_Crop = this.handle_Crop.bind(this);
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.debounceTimer = null;                                          // 디바운스 타이머를 저장할 변수
    }

    //권한체크
    async componentDidMount() {
        await Big3Common.Authentication(this);
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    handleFileSearchClick(event) {
        
        this.hiddenFileInputSimilar.current.click();
        event.preventDefault();
                
    }
    //초기화
    InitState = () => {
        this.TempFileList = [];
        this.TempImage = null;
        this.setState({
            showBackdrop: false,
            GoodsImage: null,
            CropMode: null,
            showLoading: false,
            showInfoText: true,
            RenderName: "SimilarGoods",
            SimilarList: []
        })
    }
    //첨부파일 선택 후 Change Event
    TempFileList = [];
    TempImage =null;
    handleChange(event) {
        this.TempFileList = event.target.files;
        if (Big3Common.BaseFileUpLoadConfig.FileType === Big3Common.WebConfig.UpLoadFileType.Image) {
            if (this.TempFileList.length > 0 && !this.TempFileList[0].type.includes(Big3Common.BaseFileUpLoadConfig.FileType) && this.TempFileList[0].type !== "") {
                this.TempImageList = [];
                alert("이미지 파일만 등록 가능합니다.");
                return false;
            }
        }
        this.TempImage = null;
        let ImageCount = this.TempFileList.length;
        if (ImageCount>0) {
            this.setState({
                "showBackdrop": true,
                CropMode: null,
                SimilarList: [],
                showLoading: true,
                showInfoText: false
            });
            this.FileHandler(0);
        }
        
        event.preventDefault();
    }
    //Base64 Code로 변환
    FileHandler(idx) {
        return new Promise((resolve, reject) => {
            let _this = this;
            let FileList = _this.TempFileList
            
            //#################재귀호출 종료
            if (FileList.length <= idx) {
                //처리
                this.setState({
                    "showBackdrop": false,
                    "GoodsImage": _this.TempImage
                });
            }
            else {
                let SelectFile = FileList[idx];
                let reader = new FileReader();
                if (SelectFile.name.toLowerCase().includes(".heic")) {
                    //heic 파일(아이폰) 이미지 포멧 처리
                    heic2any({ blob: SelectFile, toType: "image/jpeg" }).then(function (resultBlob) {
                        SelectFile = new File([resultBlob], SelectFile.name.split('.')[0] + ".jpg", { type: "image/jpeg", lastModified: new Date().getTime() });
                        reader.addEventListener('load', function (event) {
                            if (event.type === "load") {
                                try {
                                    let ImageProps = {
                                       
                                        Url: this.result,
                                        Size: SelectFile.size,
                                        Name: SelectFile.name,
                                        Type: SelectFile.type,
                                        Crud: "C",
                                        Guid: Big3Common.getGuid()
                                    };
                                    _this.TempImage = ImageProps;
                                }
                                catch (e) {
                                    reject(false);
                                }
                            }
                            resolve(true);
                        }, false);
                        reader.onerror = () => {
                            reject(false);
                        };
                        reader.addEventListener('loadend', function (event) {
                            if (event.type === "loadend") {
                                //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                                _this.FileHandler((idx + 1));
                                _this.SimilarCall(_this.TempImage.Url);
                            }
                        });
                        reader.readAsDataURL(SelectFile);
                    });
                }
                else {
                    //표준 이미지 포멧 처리
                    if (SelectFile instanceof Blob) {
                        const realFileReader = reader._realReader;
                        if (realFileReader) {
                            reader = realFileReader;
                        }
                    }
                    reader.addEventListener('load', function (event) {
                        if (event.type === "load") {
                            try {
                                let ImageProps = {
                                    Url: this.result,
                                    Size: SelectFile.size,
                                    Name: SelectFile.name,
                                    Type: SelectFile.type,
                                    Crud: "C",
                                    Guid: Big3Common.getGuid()
                                };
                                _this.TempImage = ImageProps;
                            }
                            catch (e) {
                                reject(false);
                            }
                        }
                        resolve(true);
                    }, false);

                    reader.onerror = () => {
                        reject(false);
                    };
                    reader.addEventListener('loadend', function (event) {
                        if (event.type === "loadend") {
                            //파일 변환 처리 후 종료 이벤트. 재귀적 호출 시작
                            _this.FileHandler((idx + 1));
                            _this.SimilarCall(_this.TempImage.Url);
                        }
                    });
                    reader.readAsDataURL(SelectFile);
                }
            }
        });
    }
    //파일 업로드
    async handleFileServerSend(BlobData) {
    
        let ImageUpLoadSize = Big3Common.BaseFileUpLoadConfig.FileSize;
        const BlobDataSize = BlobData.length;
        const Guid = Big3Common.getGuid();
        if (BlobDataSize > ImageUpLoadSize) {
            let overSize = BlobDataSize;
            overSize = Math.round((overSize) / 1024);
            let content = `첨부파일 업로드 최대용량(${(ImageUpLoadSize) / 1024}Kb)을 초과 했습니다.\n현재 파일 사이즈는 ${overSize}Kb입니다.`;
            this.InitState();
            alert(content);
            return false;
        }
        if (BlobDataSize === 0) {
            let content = '업로드할 파일이 없습니다.';
            alert(content);
            return false;
        }

        let result = await Big3Common.FileUpLoadModule("api/Search/Similar/SimilayGoodsUpLoad", {
            FileSeq: 1,
            BlobData: BlobData,
            FileSize: BlobDataSize,
            FileName: this.state.RenderName,
            FileType: Big3Common.WebConfig.UpLoadFileType.Image,
            CrudType: "C",
            Guid: Guid,
            Storage: Big3Common.BaseFileUpLoadConfig.FileStoragePath
        });

        let content = '';
        if (!result) {
            content = '업로드중 에러가 발생하였습니다. 담당자에 문의 부탁드립니다.';
            alert(content);
            return {result:false};
        }
        else {
            const today = new Date
            const yyyy = today.getFullYear(); // 연도 (yyyy)
            const mm = String(today.getMonth() + 1).padStart(2, '0'); // 월 (mm) - 1을 더해야 올바른 월이 나옴
            const dd = String(today.getDate()).padStart(2, '0'); // 일 (dd)
            const ImageURL = `/Simiar/${yyyy}/${mm}/${dd}/${Guid}_1000x1350.jpeg`;
            return { result: true, ImageURL: ImageURL };
        }
    }
    //유사도 검색 API 연동
    SimilarCall = async (BlobData) => {
        this.APICall = async (BlobData, imageType) => {
            const response = await Big3Common.SimilarPost(BlobData, imageType);
            if (response.status && response.Data.length > 0) {
                const DalpahaData = response.Data;
                //file_no를 이용한 위한 배열값 생성
                const ParamArrayData = DalpahaData
                    .filter(item => parseFloat(item.similarity) >= parseFloat(Big3Common.WebConfig.SimilarRatio))
                    .map(item => item.image_id);

                if (ParamArrayData.length === 0) {
                    this.setState({
                        showLoading: false
                    });
                    return false;
                }

                //로그기록
                Big3Common.RegisterTrackingLog({
                    [Big3Common.ContentState.Page_cd]: "SI",
                    [Big3Common.ContentState.Basket_Yn]: "N"
                });

                //클로디 이미지 조회
                const DataList = await Big3Common.Post("api/Search/Similar/GetSimilarGooodsList", {
                    data: ParamArrayData,
                    uid: "",
                    goods_no: ""
                });
                if (DataList.codeName === Big3Common.ResultCode.Success) {
                    const ImageList = JSON.parse(DataList.dataTable);
                    //조회된 이미지에 similarity비율 적용
                    const mergedList = ImageList.map(imageItem => {
                        const matchingData = DalpahaData.find(dataItem => dataItem.image_id === imageItem.image_id);
                        return {
                            ...imageItem,
                            similarity: matchingData ? parseFloat(matchingData.similarity) : 0
                        };
                    });
                    const sortedList = mergedList.sort((a, b) => b.similarity - a.similarity);
                    this.setState({
                        showLoading: false,
                        SimilarList: sortedList
                    });

                }
                else {
                    this.setState({
                        showLoading: false
                    });
                }

            }
            else {
                alert("AI 유사상품 찾기 장애가 발생 했습니다.");
                return false;
            }
        }
        //1Mb이상은 파일 업로드 후 API 연동
        if (BlobData) {
            const SendArray = BlobData.split(",");
            if (SendArray[1].length > (1024 * 1024 * 1)) {
                const Response = await this.handleFileServerSend(BlobData);
                console.log("업로드 후 조회", BlobData.length, Response);
                if (Response.result) {
                    const HostName = window.location.hostname;
                    if (HostName === "localhost") {
                        alert("개발환경에서는 요청할 수 없습니다.");
                        return false;
                    }
                    else {
                        await this.APICall(`https://${HostName}/${Response.ImageURL}`,"image");
                    }
                }
            }
            else {
                console.log("Base64 조회", BlobData.length)
                this.APICall(SendArray[1], "image_base64");
            }
        }
    }
    //Crop to Blob
    handle_Crop =  () => {
        if (this.cropperRef.current && this.cropperRef.current.cropper) {
            const croppedImageDataURL = this.cropperRef.current.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.7);
           
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(async () => {
                this.setState({
                    showLoading: true,
                    SimilarList: []
                });
                await this.SimilarCall(croppedImageDataURL);
            }, 2000);  // 2초 딜레이   
        }
    }
    //이미지 클릭으로 크롭모드 변환
    handle_ChangeCrop = (event, flag) => {
        this.setState({
            CropMode: flag
        });
        event.preventDefault();
    }
    //상세보기
    async handleGoodsDtl_Click(e, list) {
       

        this.context.Layout_GoodsDtl(
        {
                goods_no: list.goods_no,
                uid: list.uid,
                isshow: true,
                headhide: true,
                scrollevent: false
        });
        e.preventDefault();
    }
    Initrender = (css) => {
        if (this.state.showInfoText === false) {
            css = "item_hide";
        }
        return (
            <div className={`img_upload_box ${css}`}>
                <div className="icon"></div>
                <div className="title">이미지로 상품을 검색해 보세요!</div>
                <div className="text">사진을 업로드하면 비슷한 상품을<br />
                    빠르게 찾을 수 있습니다.</div>
                <label className="image_upload_btn" onClick={(e) => { this.handleFileSearchClick(e) }}>
                    <span className="camera"></span>
                    이미지 등록하기
                </label>
                <input
                    type="file"
                    style={{ display: 'none' }}
                    ref={this.hiddenFileInputSimilar}
                    onChange={this.handleChange}
                    accept="image/gif,image/jpeg,image/png,image/heic"
                    />
            </div>
        )
    }
    Photo_render = (blobData) => {
         
        return (
            <div className={`pre_wrap search_image_box ${blobData === null ? "item_hide" : ""}`}>
                <div className="pre_main_img">
                    {!this.state.CropMode ? (
                        <img src={blobData} alt="상품사진" style={{ height: 400, width: "100%" }}
                            onClick={(e) => { this.handle_ChangeCrop(e,true) }}
                        />
                    ) : (
                        <Cropper
                                src={blobData}
                                style={{ height: 400, width: "100%" }}
                                ref={this.cropperRef}
                                initialAspectRatio={0}
                                aspectRatio={0}
                                guides={true}
                                preview=".img-preview"
                                viewMode={1}
                                dragMode="move"
                                scalable={true}
                                cropBoxMovable={true}
                                cropBoxResizable={true}
                                crop={this.handle_Crop}
                        />
                    )}
                </div>
            </div>
        )
    }
    Loading_render = (css) => {
        console.log("showLoading", this.state.showLoading)
        return (
            <div className={`img_search_result_box ${css}`}>
                <div className="search_loading">
                    <DotLottiePlayer
                        src={loading}
                        background="transparent"
                        loop
                        speed="1"
                        autoplay
                    >
                    </DotLottiePlayer>
                    <div className="text">AI로 유사 이미지 검색중입니다.<br />
                        잠시만 기다려주세요!
                    </div>
                </div>
            </div>
        )
    }
    Similarrender = () => {
        if (this.state.SimilarList.length > 0) {
            return (
                <div className="d_padding img_search_result_box">
                    <div className="title"><div className="beta_tag"></div> AI가 찾은 유사 상품</div>
                    <div className="today_poroducts row row-cols-3">
                        {this.state.SimilarList.map(list =>
                            <div className="product" onClick={(e) => { this.handleGoodsDtl_Click(e, list) }} key={list.image_id}>
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                />
                                <div className="shop_name">{list.org_nm}</div>
                                <div className="product_name">{list.goods_nm}</div>
                                <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        else if (this.state.SimilarList.length === 0 && this.state.showLoading === false && this.state.GoodsImage != null) {
            return (
                <div className="recent_product result_box">
                    <div className="no_result" style={{ top:"70%"}}>
                        <div className="icon"></div>
                        <div className="text">검색결과가 없습니다.</div>
                    </div>
                </div>
            )
        }
        else {
            return (
                ""
            )
        }
        
    }
    render() {
        let blobData = null;
        if (this.state.GoodsImage !== null) {
            blobData = this.state.GoodsImage.Url;
        }
       
        return (
            <>
                <div id="parent_goods_list">
                    <header>
                        <div className="nav">
                            <Link to={-1} >
                                <div className="before">
                                    <img src={before} alt="이전화면" />
                                </div>
                            </Link>
                            <div className="page_title page_title2">
                                검색결과
                            </div>
                            {blobData === null ?
                                ""
                                :
                                <div className="header_icon_box" >
                                    <div className="main_alarm" onClick={(e) => { this.handleFileSearchClick(e) }}>
                                        <img src={img_search} alt="이미지검색아이콘" />
                                    </div>
                                </div>
                            }
                        </div>
                    </header>
                    <div>
                        {this.Initrender(blobData === null ? "" : "item_hide")}
                        {this.Photo_render(blobData)}
                        {this.Similarrender()}
                        {this.Loading_render(this.state.showLoading === true ? "" : "item_hide")}
                    </div>
                    <div>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={this.state.showBackdrop}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>
                </div>
            </>
        );
    }
}
